(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gl-brand-navigation"] && !Shopify.designMode) return;
  try {
    function setupGoldenLocksCategoryBrowsers(scope) {
  scope.querySelectorAll('.gl-category-browser').forEach((browser) => {
    if (browser.dataset.mobileReady) return;
    browser.dataset.mobileReady = 'true';
    const mobile = window.matchMedia('(max-width: 767px)');
    const sync = () => { browser.open = !mobile.matches; };
    sync();
    mobile.addEventListener('change', sync);
  });
}
setupGoldenLocksCategoryBrowsers(document);
document.addEventListener('shopify:section:load', (event) => setupGoldenLocksCategoryBrowsers(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gl-hoppe-hardware-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const summary = event.target.closest('.gl-hoppe-menu summary');
  if (!summary) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const panel = summary.parentElement;
  panel.open = !panel.open;
}, true);
  } catch(e) { console.error(e); }
})();

})();
